import { mtOnlyMenuFilters } from '../mtEnterprises';

// The standalone calendar page for multi-tenant enterprises. Other route sets
// (mcd/standard/commsHub/th) register the shared `calendarRoute`; multiClient
// follows the per-feature module convention (like sales/people/labor). This
// registers the route so `/calendar` RESOLVES 
const routes = {
  name: 'Calendar',
  nameES: 'Calendario',
  icon: 'mdi-calendar',
  path: '/calendar',
  meta: { hidePageHeader: true },
  component: () =>
    import('@/views/dashboard/widgets/calendar/ui/calendar_view.vue'),
  // MT-only: calendar birthdays are an MT-pipeline feature with no
  // MULTICLIENT_ORGS equivalent, so this entry stays narrower than the other
  // sections' `multiClientMenuFilters`.
  menuFilters: mtOnlyMenuFilters,
};

export default routes;
